import { FlexBox } from '@airship-platform/jam-web/components';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { z } from 'zod';

export type ModifierQueryInputs = { searchTerm: string; sortOrder: string };

export const ModifierQuerySchema = z.object({
  searchTerm: z.string(),
  sortOrder: z.string(),
});

const ModifierQueryForm: React.FC = () => {
  const { control } = useFormContext<ModifierQueryInputs>();

  return (
    <FlexBox flexDirection={'column'} width={'100%'} gap={2}>
      <Controller
        name="searchTerm"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            placeholder={'Search by name or description'}
            type="search"
            fullWidth
            autoComplete="off"
          />
        )}
      />

      <Controller
        name="sortOrder"
        control={control}
        render={({ field }) => (
          <RadioGroup {...field} row>
            <FormControlLabel
              value="desc"
              control={<Radio size="small" />}
              label={
                <Typography variant="caption">Savings: high to low</Typography>
              }
            />
            <FormControlLabel
              value="asc"
              control={<Radio size="small" />}
              label={
                <Typography variant="caption">Savings: low to high</Typography>
              }
            />
          </RadioGroup>
        )}
      />
    </FlexBox>
  );
};

export default ModifierQueryForm;
